export default __webpack_public_path__ + "6e27d9a6ea4509e3f13e7adba9b29fd4.svg";